import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-modifier-laboratoire',
    templateUrl: './modal-modifier-laboratoire.component.html',
    styleUrls: ['./modal-modifier-laboratoire.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, MatDialogActions, MatButton, MatDialogClose]
})
export class ModalModifierLaboratoireComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);

    public modification = '';

    public content = 'Êtes-vous sur de vouloir effectuer cette action ?';
    public cancel = 'Non';
    public confirm = 'Oui';

    constructor() {
        const data = this.data;

        if (
            data != undefined &&
            data.content != undefined &&
            data.content != ''
        )
            {this.content = data.content;}
        if (data != undefined && data.cancel != undefined && data.cancel != '')
            {this.cancel = data.cancel;}
        if (
            data != undefined &&
            data.confirm != undefined &&
            data.confirm != ''
        )
            {this.confirm = data.confirm;}
    }

    ngOnInit() {}
}
